type KeyExtractor = (data: any) => Record<string, any>;

export const keyExtractors: Record<string, KeyExtractor> = {
  token_chart: (data) => ({
    chain: data.b,
    poolAddress: data.a,
    interval: data.i,
    currency: data.c,
  }),
  token_stats: (data) => ({
    chain: data.c,
    address: data.a,
    timeFrame: data.t,
  }),
  token_price: (data) => ({
    chain: data.c,
    address: data.a,
  }),
  chain_info: (data) => ({
    chain: data.c,
  }),
  position_update: () => ({
    positionType: 'open',
  }),
};
